import * as yup from 'yup'
import { ActionDataSpec } from './action-data.js'

export enum InputMappingSource {
  TRIGGER = 'trigger',
  METADATA = 'metadata',
  PREVIOUS_STEP = 'previous-step',
  DATASTORE_VARIABLE = 'datastore-variable',
  ACTION_STEP_GROUP_CONTEXT = 'action-step-group-context',
}

export const inputMappingValueSchema = yup
  .object({
    source: yup.string().oneOf(Object.values(InputMappingSource)).required(),
    previousStepId: yup.string().when('source', {
      is: InputMappingSource.PREVIOUS_STEP,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired(),
    }),
    path: yup.string().required(),
    type: yup.string().oneOf(Object.values(ActionDataSpec)).required(),
  })
  .strict()

/**
 * Defines the value mapping for an action step's input.
 *
 * The mapping consists of the input's source, the path within that source, and the value's data
 * type. A subtype can be optionally specified for array or lookup value types. If the source of the
 * input is a previous step, that step's ID must also be specified.
 */
export type InputMappingValue = yup.InferType<typeof inputMappingValueSchema>
